import Head from "next/head";
import { FC } from "react";
import Spinner from "@components/Spinners";

const LoadingScreen: FC = () => {
    return (
        <div className="f-full flex h-screen items-center justify-center">
            <Head>
                {/*  In loading component title needs to be hard coded as string without variables as it causes weird artifacts in title when using imported variable */}
                <title>Request Accounting | Loading</title>
            </Head>
            <Spinner />
        </div>
    );
};

export default LoadingScreen;
